import axios from "axios";
import { ElMessageBox, ElMessage } from 'element-plus';
import { apiUrl, isJsonStr, MD5_Sign, QueryString, getLoginData } from "@/utils";
import { UserLogout } from "@/assets/js/fstsign";

// 记录当前接口的参数
// let dataoptions = {datas:null,url:null,method:null,isNeedLoginData:null,config:null}

//创建axios请求对象
const request = axios.create({
    baseURL: apiUrl,    //请求的基础URL
    header: {           //请求头
        'Content-Type': 'application/json',     //请求的数据格式
    }
})

//请求拦截器
request.interceptors.request.use(config => {
    //在发送请求之前做些什么...
    return config
}, error => {
    //对请求错误做些什么...
})

//响应拦截器
request.interceptors.response.use(response => {
    //对响应数据做些什么
    var res = response.data;
    if(res.retCode < 0) {
        if (res.retCode == -401 || res.retCode == -411 || res.retCode == -412 || res.retCode == -413) {
            ElMessageBox.close(false)
            ElMessageBox.alert(res.msg, '提示信息', {
                confirmButtonText: '确定',
                type: 'warning',
                callback: () => {
                    // var userinfo = JSON.parse(window.sessionStorage.getItem("user"));
                    // if (userinfo && userinfo.userType == 3) {
                    //     UserLogout("login")
                    // } else if (userinfo && userinfo.userType == 2) {
                    //     UserLogout("Admin/login")
                    // } else {
                    //     var nowTopUrl = window.top.location.href.toLowerCase()
                    //     UserLogout(nowTopUrl.indexOf("admin") > -1 ? "Admin/login" : "login")
                    // }
                    UserLogout("/login")
                }
            })
        } else{
            ElMessage({ message: response.data.msg, type: 'warning' })
        }
    }
    return response
}, error => {
    //对响应错误做些什么...
})

/**
 * 
 * @param {object} datas - 请求参数对象  参数以对象的形式传入,在此方法内统一进行转字符串处理
 * @param {string} url   - api地址请求路径
 * @param {string} method - 请求方式 可填post、get等,不填默认为post
 * @param {boolean} isNeedLoginData - 是否需要在请求头添加登录证书 true为添加,false为不添加   默认为true添加
 * @param {object} config - 其他请求配置
 */
export function getData(datas, url, method = 'post', isNeedLoginData = true, config = {}){
    // dataoptions.datas = datas;
    // dataoptions.url = url;
    // dataoptions.method = method;
    // dataoptions.isNeedLoginData = isNeedLoginData;
    // dataoptions.config = config;
    //验证参数是否为JSON字符串或JS对象
    if (!!datas) {
        if (!(isJsonStr(datas) || (typeof datas === "object"))) {
            ElMessageBox.alert('接口参数不是有效的JSON字符串或JS对象!', '提示信息', {
                confirmButtonText: '确定',
                type: 'error'
            })
            return false;
        }
        datas = typeof (datas) !== "object" ? JSON.parse(datas) : datas;
        //进行MD5签名
        datas.sign = MD5_Sign(datas);
    }
    //是否需要登陆证书
    var OtherSystemIs = QueryString("OtherSystem");
    if (OtherSystemIs) {
        let osHeadPara = Base64.decode(OtherSystemIs);
        if (!!osHeadPara) {
            if (!(isJsonStr(osHeadPara) || (typeof osHeadPara === "object"))) {
                ElMessageBox.alert('其他请求头Headers参数不是有效的JSON字符串或JS对象!', '提示信息', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                return false
            }
            osHeadPara = JSON.stringify({ ProductId: JSON.parse(osHeadPara).ProductId });
        }
        config.headers = { OtherSystem: (typeof osHeadPara == "string" ? osHeadPara : JSON.stringify(osHeadPara)) };
    } else {
        if(isNeedLoginData){
            let issykj;
            if(window.sessionStorage.getItem('ispt')){
                issykj = 1;
                config.headers = { "Authorization": encodeURIComponent(window.sessionStorage.getItem('ispt')),"Issykj" : issykj }
            }else{
                issykj = 0;
                config.headers = { "Authorization": encodeURIComponent(getLoginData()),"Issykj" : issykj }
            }
        }
    }
    const params = {
        url: url,           //请求的API地址
        data: datas,        //请求数据
        method: method || 'post',     //请求方式 可填post、get等  默认为post
        ...config
    }
    return request(params)
    .then((res) => {
        if (! res) return
        if(res.status >= 200 && res.status < 300){
            return Promise.resolve(res.data)
        }else{
            ElMessage({
                message: res.statusText,
                type: 'warning'
            })
            return Promise.reject(new Error(res.statusText))
        }
    })
    .catch((error) => {
        return Promise.reject(error)
    })
}

/**
 * @method 下载方法
 * @param {string} url  下载路径
 * @param {string} filename  文件名
 */
export function downloadUrl(url, filename) {
    if (url == '') return;
    var ajax = new XMLHttpRequest();
    ajax.open("GET", url, true);
    ajax.responseType = "blob";
    ajax.onload = function (e) {
        if (e.target.status == 200) {
            var blob = e.target.response;
            if (navigator.msSaveBlob) return navigator.msSaveBlob(blob, filename);
            url = window.URL.createObjectURL(blob);
            var anchor = document.createElement("a");
            anchor.href = url;
            anchor.setAttribute("download", filename);
            anchor.innerHTML = "downloading...";
            anchor.style.display = "none";
            document.body.appendChild(anchor);
            setTimeout(function () {
                anchor.click();
                document.body.removeChild(anchor);
            }, 66);
            return true;
        } else {
            tipsShow("未找到对应文件")
        }
    };
    ajax.send();
}